export default {

    setVersion(state, version) {
        state.version = version;
    }
};
